var animateRates = (function () {
    var rates = document.querySelectorAll('.rate-number'),
        self = {};

    function animation(item, result) {
        var step = 0.05,
            stepsCount = result / step,
            stepLength = Math.ceil(1000 / stepsCount),
            stepN = 0;

        function counter() {
            if (stepN * step < result) {
                setTimeout(function () {
                    item.innerHTML = (stepN * step).toFixed(2);
                    stepN++;
                    counter();
                }, stepLength);
            } else if (stepN * step == result) {
                setTimeout(function () {
                    item.innerHTML = (Math.round(stepN * step * 100)) / 100;
                    stepN++;
                    counter();
                }, stepLength);
            }
        }

        counter();
    }

    self.animate = function () {
        Array.prototype.forEach.call(rates, function (item) {
            var rateResult = item.dataset.rate;

            animation(item, rateResult);

        });
    };

    return self;
})();